module.exports = __webpack_public_path__ + "img/2bg.f40f5f13.png";